import AdminManagement from "../components/admin-management";


function AdminManagementPage() {
  return <AdminManagement/>;
}

export default AdminManagementPage;
